import Swal from 'sweetalert2';
import Api from '../Api';

const baseUrl = "/painel";

const sessionHelper = {
  verifyIotsNcsOpened : async () => {
    const res = await Api.getUnitysNCopenedIots(sessionStorage.getItem("client_id"), sessionStorage.getItem("userId"));

    if(res && res.some(item => parseInt(item.count_nc_iots) > 0)){

      let html = `
        Há uma ou mais NC(s) em aberto relacionadas aos seus dispositivos IOT
        <p class="mt-5 mb-5">----------- Relação da(s) NC(s): -----------</p>
        <div class="custom-swal-nc-list">
      `;

      res.forEach(item => {
        if (parseInt(item.count_nc_iots) > 0) {
          const unity = item.info_name || '';
          
          const ncIds = item.nc_ids_list.split(',').map(id => id.trim());
          const ncCreateds = item.nc_date_created_list.split(',').map(created => created.trim());
          const maintenanceTypes = item.maintenance_type_names.split(',').map(type => type.trim());
          
          html += `<p class="my-4"><b>${unity}</b></p>`;

          for (let i = 0; i < ncIds.length; i++) {
            const ncId = ncIds[i];
            const ncCreated = ncCreateds[i];
            const maintenanceType = maintenanceTypes[i] || '';
            
            html += `<p class="text-start"><b><a href="/painel/dashboard/maintenance/${ncId}">NC - ${ncId.toString().padStart(5, '0')}</a></b> (${ncCreated}) - ${maintenanceType}</p>`;
          }
        }
      });

      html += `</div>`;

      Swal.fire({
        title: 'Alerta de NC(s)',
        html: html,
        imageUrl: `${baseUrl}/assets/img/siren.gif`,
        imageWidth: 100,
        imageHeight: 100,
        allowOutsideClick: false,
        confirmButtonText: 'OK',
        customClass: {
          popup: 'custom-swal-popup',
        },
        didOpen: (popup) => {
          if (popup) popup.scrollTop = 0;
        },
      });
    }
  },

  clearUserSessions : () => {
    const prefixToRemove = 'filter_NC_';
    const prefixCToRemove = 'filter_C_';
    const prefixLastToRemove = 'lastSelected';

    //variables of filter NC list
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);

      if (key && (key.startsWith(prefixToRemove) || key.startsWith(prefixCToRemove))) {
        sessionStorage.removeItem(key);
      }
    }

    //variables from the last NC record
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);

      if (key && (key.startsWith(prefixLastToRemove))) {
        sessionStorage.removeItem(key);
      }
    }

    //others
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('siteId');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('sessionExpiration');
    sessionStorage.removeItem('countIotsNcsOpened');
    sessionStorage.removeItem('tbIssuesSearch');
  }
}

export default sessionHelper;